/*
    Put a few browser dom related function here that were difficult to 
    get working with typescript. 
*/

export function closePopup() {   
    try {
        // try to call close method in top window (in main OLX app)
        window.top.content.postMessage(JSON.stringify({
            command: "close",
        }), "*");
    }
    catch (ex) {
        // may through error testing standalone... that's ok. 
        console.log("Error trying to close;" + ex.message);
    }
}

export function callNewOrder(dnis, ani, employeeId, fileID) {
    var strURL = `DesktopDefault.aspx?tabid=100&tabindex=4&DNIS=${dnis}&ANI=${ani}&PhoneExtension=na&EmployeeID=${employeeId}&ffid=${fileID}`;
    window.top.content.openCallWin(strURL);
    //window.top.content.document.location = strURL; 
}


export function gotoCustomer(customerId) {

  let strURL = new String(window.top.content.location).toLowerCase();
  // get base
  strURL = strURL.substring(0, strURL.indexOf("desktopdefault"))
  // append new nav target... cs screen 
  strURL = strURL + `DesktopDefault.aspx?tabid=99&tabindex=5&itemid=${customerId}`;
  // GO
  window.top.content.location = strURL; 
}

export function olxPlayAudio(viewaudiopath, filename) {
  window.top.content.playAudio(viewaudiopath, filename);
}


export function registerUnsentNotificationGraphCallback(callback) {
    // register callback function at Notifications Management screen of Olx5x app (NotificationPreferences.ascx)
    window.top.content.registerUnsentNotificationGraphCallback(callback);
}

export function registerDailyNotificationGraphCallback(callback) {
    // register callback function at Notifications Management screen of Olx5x app (NotificationPreferences.ascx)
    window.top.content.registerDailyNotificationGraphCallback(callback);
}